import { useDrag } from 'react-dnd'
import { DateTime } from 'luxon'
import styled from 'styled-components'
import { useNavigateToTask } from '../../hooks'
import useIsReadOnly from '../../hooks/useIsReadOnly'
import { Colors, Spacing, Typography } from '../../styles'
import { DropType, TTaskV4 } from '../../utils/types'
import { emptyFunction } from '../../utils/utils'
import ItemContainer from '../molecules/ItemContainer'
import TaskContextMenuWrapper from '../radix/TaskContextMenuWrapper'

const TaskTitle = styled.span`
    margin-left: ${Spacing._8};
    min-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    ${Typography.body.small};
`
const TaskDueDate = styled.span`
    margin-left: auto;
    color: ${Colors.semantic.warning.base};
    ${Typography.body.small};
`
const TaskDue = styled.div`
    padding: ${Spacing._4};
    display: flex;
    align-items: center;
    overflow: hidden;
`

interface DueTaskProps {
    task: TTaskV4
    showDueDate: boolean
}
const DueTask = ({ task, showDueDate }: DueTaskProps) => {
    const navigateToTask = useNavigateToTask()
    const isReadOnly = useIsReadOnly()
    const [, drag] = useDrag(
        () => ({
            type: DropType.DUE_TASK,
            item: { id: task.id, sectionId: undefined, task },
            canDrag: !isReadOnly,
        }),
        [task, isReadOnly]
    )

    return (
        // the context menu is the only non-drag way to get a due task onto the calendar
        <TaskContextMenuWrapper task={task} onOpenChange={emptyFunction}>
            <ItemContainer
                key={task.id}
                isSelected={false}
                isCompact={true}
                onClick={() => navigateToTask({ taskId: task.id })}
                ref={drag}
            >
                <TaskDue>
                    <TaskTitle title={task.title}>{task.title}</TaskTitle>
                </TaskDue>
                {showDueDate && <TaskDueDate>{DateTime.fromISO(task.due_date).toFormat('MMM dd')}</TaskDueDate>}
            </ItemContainer>
        </TaskContextMenuWrapper>
    )
}

export default DueTask
